import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useState } from "react";
import YouTube from 'react-youtube';

const DigitalStudioVideoGallery = ({list}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [youtubeVideoError, setYoutubeVideoError] = useState(false);

    const OnYoutubeError = useCallback((event) => {
        // // The event contains a data property with the error code.
        // const errorCode = event.data;

        // // Map the YouTube error code to a readable message
        // let errorMessage = '';
        
        // switch (errorCode) {
        //     case 2:
        //         errorMessage = t(`errors.youtube_video.invalid`);
        //         break;
        //     case 5:
        //         errorMessage = t(`errors.youtube_video.player_error`);
        //         break;
        //     case 100:
        //         errorMessage = t(`errors.youtube_video.not_found`);
        //         break;
        //     case 101:
        //     case 150:
        //         errorMessage = t(`errors.youtube_video.restricted`);
        //         break;
        //     default:
        //         errorMessage = t(`errors.youtube_video.unknown`);
        // }
    }, []);

    const getYoutubeVideoID = useCallback((url) => {
        var regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w\-]{11}(?:[&?][^\s]*)?$/;
        var match = url.match(regExp);

        if (match) {
            const regExp = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
            return regExp.exec(url)[3];
        }
        else {
            return null;
        }
    }, []);

    return (
        <>
            <Box 
                className="hideScrollBar"
                sx={{ 
                    width: '100%', 
                    maxHeight: isMobile ? 500 : 1000, 
                    overflowY: 'scroll' 
                }}
            >
                <Grid
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    container
                    width='100%'
                    spacing={{xs: 1, md: 2}}
                >
                    {
                        list.map((item, index) => {
                            return <Grid
                                key={index}
                                size={{xs: 12, md: 6}}
                            >
                                <Box width='100%'>
                                    {
                                        youtubeVideoError
                                        ?
                                        <></>
                                        :
                                        <Box width='100%' sx={{backgroundColor: 'black'}}>
                                            <YouTube 
                                                videoId={getYoutubeVideoID(item)}
                                                opts={{
                                                    width: '100%',
                                                    height: window.innerWidth < 600 ? 200 : 300,
                                                    playerVars: {
                                                        // https://developers.google.com/youtube/player_parameters
                                                        autoplay: 0,
                                                        color: 'white',
                                                        origin: window.location.origin
                                                    }
                                                }}
                                                onError={OnYoutubeError}
                                                onReady={() => setYoutubeVideoError(false)}
                                                host="https://www.youtube-nocookie.com"
                                            />
                                        </Box>
                                    }
                                </Box>
                            </Grid>
                        })
                    }
                </Grid>
            </Box>
        </>
    );
}

export default DigitalStudioVideoGallery;